import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

export default function SessionsPage() {
  const { t } = useTranslation()
  return (
    <Box>
      <Typography variant="h4" gutterBottom>{t('navigation.sessions')}</Typography>
      <Typography color="text.secondary">My Sessions - coming soon.</Typography>
    </Box>
  )
}
